import { format, isValid, parse } from "date-fns"

export function useDate() {
    function dateToClient(strDate) {
        const date = new Date(strDate)
        if (isValid(date)) {
            return format(date, "dd/MM/yyyy")
        }
        return strDate
    }

    function datetimeToClient(strDate) {
        const date = new Date(strDate)
        if (isValid(date)) {
            return format(date, "dd/MM/yyyy HH:mm")
        }
        return strDate
    }

    function dateToDatabase(strDate) {
        const parsed = parse(strDate, "dd/MM/yyyy", new Date())
        if (isValid(parsed)) {
            return format(parsed, "yyyy-MM-dd HH:mm:ss")
        }
        return strDate
    }

    return {
        dateToClient,
        datetimeToClient,
        dateToDatabase,
    }
}
